module.exports = __webpack_public_path__ + "public/images/schedule/schedule-table.6b0e800565c5af42b40108a126a647aa.svg";